import {
  WSButton,
  WSGrid,
  WSPage,
  WSPanel,
  WSTabs,
  WSText
} from "@wingspanhq/fe-component-library";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import { RouteComponentProps, useHistory } from "react-router-dom";
import { useQueryPayeeTaxForm } from "../../../../query/taxForm/queries/useQueryPayeeTaxForm";
import { WSQueries } from "../../../../query/WSQuery";
import { getPaymentsLinkForTaxDocument } from "../../../TaxDocuments/utils/getPaymentsLinkForTaxDocument";
import { getYearDateRange } from "../../../TaxDocuments/utils/getYearDateRange";
import { DocumentHistory } from "./DocumentHistory";
import { Footer } from "./Footer";
import { Header } from "./Header";
import { Payments } from "./Payments";
import { Summary } from "./Summary";

export const RouteDetailsOld: React.FC<
  RouteComponentProps<{
    taxFormId: string;
  }>
> = ({
  match: {
    params: { taxFormId }
  }
}) => {
  const history = useHistory();
  const queryTaxForm = useQueryPayeeTaxForm(taxFormId);

  return (
    <WSPage>
      <WSQueries queries={{ queryTaxForm }}>
        {({ queryTaxForm: { data: taxForm } }) => (
          <>
            <Header taxForm={taxForm} mb="2XL" />
            <WSGrid>
              <WSGrid.Item span={{ m: "6" }}>
                <WSPanel
                  mb="2XL"
                  style={{ backgroundColor: "currentColor" }}
                  color="gray50"
                >
                  <WSText.ParagraphSm color="gray500">
                    1099 NEC-Total
                  </WSText.ParagraphSm>
                  <WSText.Display2 mb="M">
                    {taxForm.data?.totalAmount
                      ? formatMoney(taxForm.data?.totalAmount, "USD")
                      : "-"}
                  </WSText.Display2>
                  <WSButton.Link
                    onClick={() => {
                      const defaultRange = getYearDateRange(taxForm.year);

                      history.push(
                        getPaymentsLinkForTaxDocument(
                          taxForm.clientId,
                          defaultRange.startDate,
                          defaultRange.endDate
                        )
                      );
                    }}
                  >
                    See payments included in the 1099 total
                  </WSButton.Link>
                </WSPanel>

                <WSTabs
                  tabs={[
                    {
                      label: "Summary",
                      render: () => <Summary taxForm={taxForm} />
                    },
                    {
                      label: "Payments",
                      render: () => <Payments taxForm={taxForm} />
                    }
                  ]}
                />
              </WSGrid.Item>
              <WSGrid.Item span={{ m: "6" }}>
                <DocumentHistory mb="2XL" taxForm={taxForm} />
              </WSGrid.Item>
            </WSGrid>
            <Footer my="2XL" />
          </>
        )}
      </WSQueries>
    </WSPage>
  );
};
